import { 
  submitPurchaseOrder, 
  updatePurchaseOrderItem, 
  updatePurchaseOrderItemQuantity,
  deletePurchaseOrderItem,
  getCurrentDraftPO,
  getPurchaseOrdersList,
  getPurchaseOrderById,
  setPurchaseOrderBranch,
  DraftPurchaseOrder,
  PurchaseOrderListItem
} from '../../shared/purchaseOrderCatalog';

// Params for submit purchase order
interface SubmitPurchaseOrderParams {
  componentId: string;
  tenantId: number;
  branchId: number;
  body: {
    branch_id: number;
    payment_method_id: number;
    additional_notes: string;
  };
}

// Params for update purchase order item
interface UpdatePurchaseOrderItemParams {
  componentId: string;
  tenantId: number;
  body: {
    purchase_requests_ids: number[];
  };
}

// Params for update purchase order item quantity
interface UpdatePurchaseOrderItemQuantityParams {
  componentId: string;
  tenantId: number;
  body: {
    tenant_product_id: number;
    quantity: number;
  };
}

// Params for delete purchase order item
interface DeletePurchaseOrderItemParams {
  componentId: string;
  tenantId: number;
  body: {
    tenant_product_id: number;
  };
}

// Params for get current draft PO
interface GetCurrentDraftPOParams {
  tenantId: number;
  componentId: string;
}

// Params for get purchase orders list
interface GetPurchaseOrdersListParams {
  componentId: string;
  tenantId: string;
  branchesIds: string;
  sort: string;
  page: number;
  size: number;
}

interface GetPurchaseOrderByIdParams {
  componentId: string;
  tenantId: string;
  poId: string;
}

// Params for set purchase order branch
interface SetPurchaseOrderBranchParams {
  componentId: string;
  tenantId: string;
  branchId: string;
}

// Export parameter types
export type { 
  SubmitPurchaseOrderParams, 
  UpdatePurchaseOrderItemParams, 
  UpdatePurchaseOrderItemQuantityParams,
  DeletePurchaseOrderItemParams,
  GetCurrentDraftPOParams,
  GetPurchaseOrdersListParams,
  GetPurchaseOrderByIdParams,
  SetPurchaseOrderBranchParams,
  DraftPurchaseOrder,
  PurchaseOrderListItem
};

export const purchaseOrderQueries = {
  queries: {
    getCurrentDraftPO: (params: GetCurrentDraftPOParams) => ({
      queryKey: ['purchase-order', 'draft', params.tenantId, params.componentId],
      queryFn: () => getCurrentDraftPO(params.tenantId, params.componentId)
    }),
    getPurchaseOrdersList: (params: GetPurchaseOrdersListParams) => ({
      queryKey: ['purchase-order', 'list', params.componentId, params.tenantId, params.branchesIds, params.sort, params.page, params.size],
      queryFn: () => getPurchaseOrdersList(params.componentId, params.tenantId, params.branchesIds, params.sort, params.page, params.size)
    }),
    getPurchaseOrderById: (params: GetPurchaseOrderByIdParams) => ({
      queryKey: ['purchase-order', 'by-id', params.componentId, params.tenantId, params.poId],
      queryFn: () => getPurchaseOrderById(params.componentId, params.tenantId, params.poId)
    })
  },
  mutations: {
    submitPurchaseOrder: (params: SubmitPurchaseOrderParams) => ({
      mutationKey: ['purchase-order', 'submit', params.componentId, params.tenantId, params.branchId,params.body.additional_notes],
      mutationFn: () => submitPurchaseOrder(params.componentId, params.tenantId, params.branchId, params.body)
    }),
    updatePurchaseOrderItem: (params: UpdatePurchaseOrderItemParams) => ({
      mutationKey: ['purchase-order', 'update-item', params.componentId, params.tenantId],
      mutationFn: () => updatePurchaseOrderItem(params.componentId, params.tenantId, params.body)
    }),
    updatePurchaseOrderItemQuantity: (params: UpdatePurchaseOrderItemQuantityParams) => ({
      mutationKey: ['purchase-order', 'update-item-quantity', params.componentId, params.tenantId, params.body.tenant_product_id],
      mutationFn: () => updatePurchaseOrderItemQuantity(params.componentId, params.tenantId, params.body)
    }),
    deletePurchaseOrderItem: (params: DeletePurchaseOrderItemParams) => ({
      mutationKey: ['purchase-order', 'delete-item', params.componentId, params.tenantId, params.body.tenant_product_id],
      mutationFn: () => deletePurchaseOrderItem(params.componentId, params.tenantId, params.body)
    }),
    setPurchaseOrderBranch: (params: SetPurchaseOrderBranchParams) => ({
      mutationKey: ['purchase-order', 'set-branch', params.componentId, params.tenantId, params.branchId],
      mutationFn: () => setPurchaseOrderBranch(params.tenantId, params.componentId, params.branchId)
    })
  }
};
